import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  buttonGroup: {
    marginBottom: '10px',
  },
  buttonTab: {
    color: 'white',
    marginRight: '20px',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
  },
  activeButton: {
    fontWeight: '700',
    borderBottom: 'white solid 2px',
  },
  container: {
    background: 'rgba(0, 0, 0, 0.25)',
    borderRadius: '16px',
    margin: '16px 0 16px',
    display: 'flex',
    flexDirection: 'column',
  },
  selectContainer: {
    maxHeight: '285px',
    overflow: 'auto',
    padding: '0 18px',
    height: '100%',
  },
  mintButton: {
    marginTop: '16px',
    borderRadius: '100px',
    width: '100%',
  },
  arrowContainer: {
    display: 'flex',
    borderRadius: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    background: 'rgba(0, 0, 0, 0.25)',
    width: '40px',
    height: '40px',
    color: '#F0B90B',
  },
  inputContainerBot: {
    marginTop: '16px',
  },
  inputContainer: {
    marginBottom: '16px',
  },
  inputContainerMulti: {
    margin: '16px 0',
  },
  containerTitle: {
    margin: '16px',
    textAlign: 'center',
    lineHeight: '160%',
    color: '#9F9F9F',
  },
  containerTitleMain: {
    color: '#F0B90B',
    fontWeight: 'bold',
  },
  description: {
    lineHeight: '160%',
    marginBottom: '32px',
  },
  backButton: {
    borderRadius: '32px',
  },
});
